import {Box, FormControl, FormHelperText, Typography} from '@mui/material';
import SelectV2 from './SelectV2';
import {VersionVariants} from '@jobseeker/lotus/enums/variants';
import {CourseEnquiryPopupType} from './types';

const expYearOptions = Array.from({length: 33}).map((_, i) => ({
  label: i === 32 ? '30+' : i > 0 ? `${i - 1}` : 'Select experience',
  value: i,
}));

const ExperienceYear = (props: CourseEnquiryPopupType) => {
  const {formik, menuOpen, setMenuOpen} = props;
  return (
    <Box
      sx={{
        mt: formik.touched.name && formik.errors.name?.length ? 0.875 : 3,
        width: '100%',
      }}
    >
      <Typography
        sx={{
          color: '#333',
          fontSize: '14px',
          fontStyle: 'normal',
          fontWeight: 500,
          lineHeight: '18px',
        }}
      >
        Total Work Experience (in years)&#42;
      </Typography>
      <FormControl
        id="expYearCoursePage"
        key="expYearCoursePage"
        error={
          formik.touched.expYearCoursePage &&
          Boolean(formik.errors.expYearCoursePage)
        }
        sx={{
          display: 'block',
          mt: 1,
        }}
      >
        <SelectV2
          menuOpen={menuOpen === 'expYearCoursePage'}
          setMenuOpen={setMenuOpen}
          variant={VersionVariants.VERSION_TWO}
          options={expYearOptions}
          label={'Select experience'}
          name="expYearCoursePage"
          key="expYearCoursePage"
          value={[formik.values.expYearCoursePage]}
          onChange={formik.handleChange}
          error={
            formik.touched.expYearCoursePage &&
            Boolean(formik.errors.expYearCoursePage)
          }
        />
        {formik.touched.expYearCoursePage &&
          Boolean(formik.errors.expYearCoursePage) && (
            <FormHelperText>{formik.errors.expYearCoursePage}</FormHelperText>
          )}
      </FormControl>
    </Box>
  );
};

export default ExperienceYear;
